import { Component, Input, OnInit } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { UserPermission } from 'src/app/enums/enums';
import { PermissionService } from 'src/app/services/app/permission-access-service/permissionBased.service';
import { ConfigurationService } from 'src/app/services/core/configuration/configuration.service';
import { SpaceTypeService } from 'src/app/services/core/spaceTypes/space-type.service';
import { ThresholdService } from 'src/app/services/core/threshold/threshold.service';
import { NUMBER_OF_RECORDS } from 'src/app/utils/common.utils';
@UntilDestroy()

@Component({
  selector: 'app-threshold-list',
  templateUrl: './threshold-list.component.html',
  styleUrls: ['./threshold-list.component.css']
})
export class ThresholdListComponent implements OnInit {
  @Input() companyId:any
  threshold: any;
  spacetypes: any;
  preSpacetypes: any;
  currentPage: number = 1;
  totalPages = 0;
  totalResults = 0;
  numberOfRecords = NUMBER_OF_RECORDS;
  filteredThresholdList:any = [];
  status:boolean = true;
  userPermission=UserPermission
  thresholdModalObj:any;
  logObj:any;

  constructor(
    private thresholdService: ThresholdService,
    private spaceTypeService: SpaceTypeService,
    public permissionService: PermissionService
  ) {}
  
  ngOnInit(): void {
    this.getSpaceType();
    this.getThresHold(this.currentPage)
  }

  getThresHold(page: number) {
    const queryparams = {
      limit: 50,
      page,
      isActive : this.status
    }
    this.thresholdService.getThreshold(this.companyId,queryparams)
      .pipe(untilDestroyed(this)).subscribe((data: any) => {
        if (data) {
          this.threshold = data.results;
          this.threshold = data.results.sort((a: any, b: any) =>
            new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
          );
          this.filteredThresholdList = [...this.threshold]
          this.totalPages = data.totalPages;
          this.totalResults = data.totalResults;
        }
      })
  }

  getSpaceType() {
    this.spaceTypeService.getPicker({ isActive: true, limit: 9999 }).pipe(untilDestroyed(this)).subscribe((data: any) => {
      if (data && data.results ) {
        this.spacetypes = data.results;
        this.preSpacetypes = this.spacetypes.reduce((obj: any, item: any) => (obj[item.id] = item, obj), {});
      }
    })
  }

  onPageChange(page: number) {
     this.currentPage = page;
     this.getThresHold(page);
  }

  onSelectStatus(): void {
    this.getThresHold(this.currentPage = 1);
  }


  openThresholdEditModal(vehicle: any) {
    this.thresholdModalObj = vehicle;
  }

  onSaveThreshold(evt: any) {
    if (evt) {
      const idx = this.filteredThresholdList.findIndex((fs: any) => fs.id === evt.id);
      if (this.status === evt.isActive) {
        this.filteredThresholdList[idx] = evt;
      } else {
        this.filteredThresholdList.splice(idx, 1);
      }
    }
    this.thresholdModalObj = null;
  }

  onCloseThresholdModal() {
    this.thresholdModalObj = null;
  }
  
  openLogModal(fare:any){
    this.logObj = fare.id;
  }
}
